import { styled } from '@mui/material/styles'
import React from 'react'
import { Labeled, useTranslate } from 'react-admin'
import KNumberInput from 'ui-shared/WrappedInputs/KNumberInput'
import { computeQuantityByMaxParticipants } from '../common'
import { QuantityHint } from 'types/common'
import { WithQuantityHint } from '../types'
import { useWatch } from 'react-hook-form'

const PREFIX = 'DefaultQuantityHint'

const classes = {
  fieldsBox: `${PREFIX}-fieldsBox`,
  fieldWidth: `${PREFIX}-fieldWidth`,
  ml55: `${PREFIX}-ml55`,
}

const StyledDiv = styled('div')(() => ({
  [`& .${classes.fieldsBox}`]: {
    display: 'flex',
    flexDirection: 'row',
    gap: '100px',
    width: '100%',
  },

  [`& .${classes.fieldWidth}`]: {
    width: '300px',
  },

  [`& .${classes.ml55}`]: {
    marginLeft: '50px',
  },
}))

export type QuantityHintProps = {
  guestsNumberMock: number
  quantityHint: QuantityHint[]
}

const DefaultQuantityHint: React.FC<QuantityHintProps> = ({
  guestsNumberMock,
  quantityHint,
}) => {
  const translate = useTranslate()
  const defaultQuantityHint = useWatch<WithQuantityHint, 'defaultQuantityHint'>(
    {
      name: 'defaultQuantityHint',
    }
  )

  return (
    <StyledDiv>
      <div className={[classes.fieldsBox, classes.ml55].join(' ')}>
        <div className={classes.fieldWidth}>
          {translate('form.fields.default')}
        </div>
        {/* This is a workaround because the form does not react to the setup in the parse */}
        <KNumberInput
          source="defaultQuantityHint.maxParticipants"
          style={{ display: 'hidden', width: '0px' }}
          defaultValue={10000}
        />
        <KNumberInput
          source="defaultQuantityHint.quantityMultiplier"
          label="form.fields.quantityMultiplier"
          className={classes.fieldWidth}
          defaultValue={100}
        />
        <Labeled label="Simulated quantity" className={classes.fieldWidth}>
          <div>
            {computeQuantityByMaxParticipants(
              quantityHint,
              defaultQuantityHint?.maxParticipants,
              defaultQuantityHint?.quantityMultiplier,
              guestsNumberMock
            )}
          </div>
        </Labeled>
      </div>
    </StyledDiv>
  )
}

export default DefaultQuantityHint
